<template>
  <div id="app" :class="{ padded: !searchActive }">
    <b-navbar
      toggleable
      variant="white"
      type="light"
      id="main-nav-top"
      :class="{ 'p-0 sticky-top': searchActive, 'pt-3': !searchActive }"
    >
      <div
        id="omnibar"
        class="flex-grow-1 rounded p-2 d-flex justify-content-between align-items-center"
        :class="{ 'border-bottom': searchActive, shadowed: !searchActive }"
      >
        <div
          class="m-0 p-0 pr-2 pl-1"
          id="omnibar-toggle"
          @click="toggleCurrent"
        >
          <span class="navbar-toggler-icon" v-if="!searchActive"></span>
          <span v-else style="font-size:1.1em;padding:0 3px;"
            ><b-icon-arrow-left class="text-dark"></b-icon-arrow-left
          ></span>
        </div>
        <input
          type="text"
          class="border-0 flex-grow-1 p-1"
          id="omnibar-fakeinput"
          placeholder="Suchen..."
          :value="searchQuery"
          @input="search($event.target.value)"
          @focus="$store.commit('SEARCH_ACTIVE', true)"
        />
        <img
          v-b-tooltip.focus="'Cheese!'"
          tabindex="0"
          src="@/assets/cheese.png"
          height="20"
          class="ml-2 mr-1"
        />
      </div>
    </b-navbar>
    <router-view v-if="!searchActive" />
    <div v-if="searchActive" class="pt-2">
      <b-modal
        v-model="modalDateShow"
        title="Datum auswählen"
        cancel-title="Abbrechen"
        @ok="addToPlan"
      >
        <template slot="modal-header">
          <small
            >Datum auswählen für: <b>{{ currentRecipe.title }}</b></small
          >
        </template>
        <b-calendar
          v-model="selectedDate"
          locale="de"
          start-weekday="1"
          block
        ></b-calendar>
      </b-modal>
      <b-list-group>
        <div v-if="loading" class="text-center p-3">
          <b-spinner small></b-spinner>
        </div>
        <template v-else>
          <Recipe
            v-for="item in recipes"
            :item="item"
            :key="item.id"
            @click="selectDateForRecipe(item)"
            showDetails
            showEdit
            @edit="showEdit(item)"
          />
          <b-container
            fluid
            v-if="recipes.length === 0 && searchQuery.length > 0"
            class="text-muted"
          >
            Keine Ergebnisse.
          </b-container>
          <b-container
            fluid
            v-if="recipes.length === 0 && searchQuery.length === 0"
            class="text-muted"
          >
            Bitte Suchbegriff eingeben.
          </b-container>
        </template>
      </b-list-group>
    </div>
    <b-navbar
      variant="white"
      type="light"
      id="main-nav-bottom"
      fixed="bottom"
      class="py-0 border-top d-flex align-items-center"
      v-if="!searchActive"
    >
      <router-link to="/home" class="view-switch" tag="div">
        <b-icon-kanban></b-icon-kanban><br />
        <small><strong>Planer</strong></small>
      </router-link>
      <router-link to="/recipes" class="view-switch" tag="div">
        <b-icon-book></b-icon-book><br />
        <small><strong>Rezepte</strong></small>
      </router-link>
      <router-link to="/notes" class="view-switch" tag="div">
        <b-icon-cart></b-icon-cart><br />
        <small><strong>Einkaufsliste</strong></small>
      </router-link>
    </b-navbar>
    <b-sidebar id="sidebar-1" title="Cheese" shadow backdrop>
      <div class="px-3 py-2">
        <p class="text-center">
          <b-img src="@/assets/cheese.png" fluid thumbnail></b-img>
        </p>
        <p>
          Cheese erleichtert die Planung und den Einkauf von Lebensmitteln.
        </p>
        <b-btn block @click="refreshContent">Neu laden</b-btn>
      </div>
    </b-sidebar>
    <b-sidebar id="sidebar-right" title="Details" right shadow backdrop>
      <div class="py-2" v-if="detailItem">
        <b-container fluid class="font-weight-bold">
          {{ detailItem.title }}
        </b-container>
        <b-container
          fluid
          class="font-weight-light mt-2"
          v-if="detailItem.recipe.length > 0"
        >
          <div class="text-muted font-weight-light">
            Rezept
          </div>
          <b-row
            v-for="(ingredient, i) in detailItem.recipe"
            :key="'ing-' + detailItem.id + '-' + i"
          >
            <b-col cols="3">{{ ingredient.amount }}{{ ingredient.unit }}</b-col>
            <b-col cols="9">{{ ingredient.title }}</b-col>
          </b-row>
        </b-container>
        <b-container
          fluid
          class="font-weight-light mt-2"
          v-if="detailItem.instructions.length > 0"
        >
          <div class="text-muted font-weight-light">
            Zubereitung
          </div>
          <b-row
            v-for="(instruction, i) in detailItem.instructions"
            :key="'istr-' + detailItem.id + '-' + i"
          >
            <b-col cols="2">{{ i + 1 }}.</b-col>
            <b-col cols="10">{{ instruction.title }}</b-col>
          </b-row>
        </b-container>
      </div>
    </b-sidebar>
    <EditModal :currentRecipe="detailItem" v-model="modalEditShow" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import Recipe from "@/components/Recipe.vue";
import { getRecipe } from "@/class/recipe";
import EditModal from "@/components/EditModal.vue";
import axios from "axios";
import _ from "lodash";

export default {
  name: "App",
  components: {
    Recipe,
    EditModal
  },
  data() {
    return {
      searchQuery: "",
      modalDateShow: false,
      currentRecipe: {
        title: ""
      },
      recipes: []
    };
  },
  computed: {
    selectedDate: {
      get() {
        return this.$store.state.selectedDate;
      },
      set(value) {
        this.$store.commit("SELECTED_DATE", this.moment(value));
      }
    },
    ...mapState({
      // arrow functions can make the code very succinct!
      loading: state => state.loading,
      searchActive: state => state.searchActive,
      moment: state => state.moment,
      detailItem: state => state.detailItem,
      modalEditShow: state => state.modalEditShow
    })
  },
  created() {
    //this.$store.dispatch("getData");
  },
  methods: {
    search: _.debounce(function(val) {
      this.searchQuery = val;
      this.recipes = [];
      if (this.searchQuery.length === 0) {
        return true;
      }
      this.$store.commit("SET_LOADING", true);
      axios
        .post(process.env.VUE_APP_API_URL + "?recipe", {
          cmd: "search",
          q: this.searchQuery,
          limit: 20
        })
        .then(r => {
          this.recipes.push(...r.data);
        })
        .finally(() => {
          this.$store.commit("SET_LOADING", false);
        });
    }, 200),
    showEdit(item) {
      getRecipe(item.id).then(recipe => {
        this.$store.commit("SET_DETAILITEM", recipe);
        this.$store.commit("SHOW_EDITMODAL", true);
      });
    },
    toggleCurrent() {
      if (this.searchActive) {
        this.$store.commit("SEARCH_ACTIVE", false);
        this.searchQuery = "";
        this.search("");
      } else {
        this.$root.$emit("bv::toggle::collapse", "sidebar-1");
      }
    },
    refreshContent() {
      window.location.reload(true);
    },
    selectDateForRecipe(recipe) {
      this.currentRecipe = recipe;
      this.modalDateShow = true;
      //
    },
    addToPlan() {
      this.$store
        .dispatch("addToPlan", {
          date: this.moment(this.selectedDate),
          id: this.currentRecipe.id
        })
        .then(() => {
          this.$store.commit("SEARCH_ACTIVE", false);
          this.searchQuery = "";
        });
    }
  }
};
</script>

<style lang="scss">
$fixedNavHeight: 60px;
#app.padded {
  padding-bottom: $fixedNavHeight;
}
#omnibar {
  &.shadowed {
    box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.25);
  }
  color: #a0a0a0;
  #omnibar-toggle {
    font-size: 0.8em;
  }
  #omnibar-fakeinput {
    color: #444444;
    outline: none;
  }
}
#main-nav-tabs {
  .view-tab {
    height: 28px;
    padding: 0 10px;
    color: #777;
    line-height: 0.85;
    text-align: center;
    border-bottom: 2px solid #ffffff;
    &.router-link-exact-active {
      color: #e9b313;
      border-bottom: 2px solid #e9b313;
    }
  }
}
#main-nav-bottom {
  height: $fixedNavHeight;
  .view-switch {
    flex: 1;
    color: #777;
    line-height: 0.85;
    text-align: center;
    .b-icon {
      font-size: 20px;
    }
    &.router-link-active {
      color: #e9b313;
    }
  }
}
.badge-purple {
  background-color: purple;
  color: white;
}
.recipeType {
  width: 25px;
}
</style>
